<a class="link-reset" [routerLink]="routerLink()">
  <article class="page-list-card card">
    <fstr-image class="page-list-card__image" [image]="image()" [width]="200" [height]="200" [colSpan]="{ sm: 2, lg: 3 }"></fstr-image>

    <main>
      @if (date() || type()) {
        <span class="text-primary fs-body-xs mb-1">
          @if (date()) {
            {{ date()! | newsDate }} |
          }

          <span>{{ type() }}</span>
        </span>
      }
      <h2 class="h6 fw-normal max-lines-2 mb-max-lines pe-3">{{ title() }}</h2>
    </main>
  </article>
</a>
